import React, { Component } from "react";
import { connect } from "react-redux";
import { signIn } from "../../actions/authActions";
import { RESPONSE_STATUS } from "../../utils/constants";
import * as util from "../../utils/util";
import * as HttpUtils from "../../utils/http";
import { Loader } from 'semantic-ui-react'
import Api from '../../utils/api';

class RegistrationPage extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fun_submitUserRegistration = this.fun_submitUserRegistration.bind(this);
    this.fun_UserRegistrationManage = this.fun_UserRegistrationManage.bind(this);

    this.state = {
        submitted: false,
        email: "",
        phoneNumber: "",
        password: "",
        accountExist: false,
        emailInvalid: false,
        phoneInvalid: false,
        errorMessage: "",
        accountOptIn: false,
        phoneCountry:'US',
        butLoadShow:false,
    }
  }

  componentDidMount(){
    // ReactGA 配合谷歌跟踪
    try {
      let skinQuizType = this.props.skinQuizType;
      if(skinQuizType)
      Api.eventTrackingStageProgress(skinQuizType.replace("SQ_",""));
    } catch (error) {}
  }

  componentWillMount() {
    if (window.location.pathname.includes("/ath"))
      this.setState({ accountOptIn: true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated) {
      this.props.triggerNextStep();
    }
  }

  handleChange = e => {
    let output = e.target.value;
    let phoneOutput;
    if (e.target.name === "phoneNumber") {
      let input = output;
      input = input.replace(/[^0-9]/g, "");

      let area = input.substr(0, 3);
      let pre = input.substr(3, 3);
      let last = input.substr(6, 4);

      if(this.state.phoneCountry == 'UK'){
        phoneOutput = output.substr(0, 10);
      }else{
        if (area.length < 3) {
          phoneOutput = "(" + area;
        } else if (area.length === 3 && pre.length < 3) {
          phoneOutput = "(" + area + ") " + pre;
        } else if (area.length === 3 && pre.length === 3) {
          phoneOutput = "(" + area + ") " + pre + "-" + last;
        }
      }
   
      this.setState({ [e.target.name]: phoneOutput });
      return;
    }else if(e.target.name === "phoneCountry"){
      this.setState({
        phoneNumber: ''
      });
    }

    this.setState({ [e.target.name]: output });
  };

  handleEmailInputComplete = () => {
    const email = this.state.email;
    if (email) {
      fetch("/api/account/status?email=" + email)
        .then(response => response.text())
        .then(status => {
          this.setState({
            accountExist: status === "true",
            emailInvalid: false
          });
        });
    }
  };

  handleEmailInputCompleteAth = () => {
    const email = this.state.email;
    const url = "/api/ath/users/exist?email=" + email;
    if (email && email !== "") {
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }).then(response => {
        if (response.status >= 400 && response.status < 500)
          this.setState({ accountExist: false, emailInvalid: false });
        else if (response.status >= 200 && response.status < 300)
          this.setState({
            accountExists: true,
            errorMessage: "Account already exists."
          });
      });
    }
  };

  handleKeyPressed(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleSubmit();
    }
  }

  handleKeyDown(e) {
    let key = e.keyCode;
    if (key === 8) {
      let output = e.target.value;
      if (output.slice(-1) === " ") {
        output = output.substring(0, output.length - 2);
      } else {
        output = output.substring(0, output.length - 1);
      }
      this.setState({ [e.target.name]: output });
    }
  }

  gtag_report_conversion_create_an_account(url) {
    let callback = function() {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };
    window.gtag("event", "conversion", {
      send_to: "AW-782420739/LOabCPiL74wBEIOWi_UC",
      event_callback: callback
    });
    return false;
  }

  handleSubmit() {
    const { email, password, phoneNumber } = this.state;

    if (this.state.accountExist) {
      if (email && password) {
        this.props.signIn(email, password);
      }else{
        alert("Please enter all the information");
      }
    } else {
      if (email && password && phoneNumber) {

        const isValidEmail = util.isValidEmail(email);
        const isValidPhone = util.isValidPhone(phoneNumber);

        if (!isValidEmail) {
          alert('Please enter a correct email address');
          return false;
        }

        if(!isValidPhone){
          alert('Please enter a correct Phone');
          return false;
        }

        this.setState({ submitted: true });
        //GA Tracking Account Creation
        if (window.dataLayer && window.dataLayer.push){
          window.dataLayer.push({ event: "Create_account" });
          // this.gtag_report_conversion_create_an_account();
          window.fbq("trackCustom", "RegisteredAfterOnboarding");
          //Removed CompleteRegistration 07/22/2019
          // window.fbq('track', 'CompleteRegistration');
        }

        this.fun_submitUserRegistration();
      }else{
        alert("Please enter all the information");
      }
    }
  }

  // 用户注册
  fun_submitUserRegistration(){
    let signupPurposeId = '';
    try {
       signupPurposeId = localStorage.getItem("SQ_signupPurposeId");
    } catch (error) {
      console.error(error);
    }
    this.setState({ butLoadShow:true });
    const { email, password, phoneNumber } = this.state;
    HttpUtils.post("/api/surveys/advanced",{
      email:email,
      phoneNumber:phoneNumber,
      password:password,
      region: util.transformationCountryNumberId(this.state.phoneCountry),
      signupPurposeIds: signupPurposeId,
    },false).then((response)=>{
      this.setState({ butLoadShow:false });
      this.fun_UserRegistrationManage(response);
      this.props.triggerNextStep({ value: email + ":" + phoneNumber +":" + password + ":" + util.transformationCountryNumberId(this.state.phoneCountry) });
    }).catch(err => {
      this.setState({ butLoadShow:false });
      alert("Please contact helloava management");
    })
  }

  fun_UserRegistrationManage(response){
    const { email, phoneNumber } = this.state;

    try {
      localStorage.setItem("auth_token", response.token.token);
      localStorage.setItem("auth_expires", parseInt(response.token.expires / 1000));
      localStorage.setItem("user_id", response.userId);
      localStorage.removeItem("gateFeePaid");
      localStorage.setItem("temp_new_user_flag", true);
      localStorage.setItem("recohasnotseenreco", true);

      localStorage.setItem("phone_number", phoneNumber);
      localStorage.setItem("user_global_phone", phoneNumber);
      localStorage.setItem("email", email);
      localStorage.setItem("user_global_email", email);
    } catch (error) {
      console.error(error);
    }

  }


  renderErrorMessage() {
    if (
      this.state.emailInvalid ||
      this.state.phoneInvalid ||
      (this.props.authFailed &&
        this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED) ||
      this.state.errorMessage.length > 0
    )
      return (
        <div className="error-message">
          {this.state.emailInvalid && <p>Invalid email. Please try again.</p>}
          {this.state.phoneInvalid && (
            <p>Invalid phone number. Please try again.</p>
          )}
          {this.props.authFailed &&
            this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED && (
              <p>
                Your account already exists! Please enter the correct password
                to access your profile.
              </p>
            )}
          {this.state.errorMessage}
        </div>
      );
    return null;
  }




  // handleSubmit(){
  //   this.setState({ submitted: true });
  //   this.props.triggerNextStep();
  // }

  render() {
    return (
        <div className="onb-resistration-container">
            <ul className="resistration-input-ul">
                <li>
                    <span>Your email</span>
                    <input type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleChange} autoComplete = "off"
                      onBlur={window.location.pathname.includes("/ath")? this.handleEmailInputCompleteAth: this.handleEmailInputComplete} onKeyPress={this.handleKeyPressed.bind(this)} onFocus={() => {this.setState({ errorMessage: "" }); }} ></input>
                </li>
                <li>
                    <span>Create a password</span>
                    <input type="password" name="password" placeholder="Password" value={this.state.password} onChange={this.handleChange} onKeyPress={this.handleKeyPressed.bind(this)}></input>
                </li>
                <li>
                    <span>Your phone number</span>
                    <div className="referral-new-input-select-conten">
                      <div className="select-country-area" style={ this.state.phoneNumber ? {  position: 'absolute', paddingLeft: '10px',height:'43px'} : {display:'none'} }>
                          <div className="select-country-text" style={{fontSize: '10px', textAlign: 'left', color: '#272D67'}}>+{ util.getCountry(this.state.phoneCountry)} </div>
                          <select className="select-country-phone" style={{fontSize: '14px',color: '#272D67'}} name="phoneCountry" onChange={this.handleChange}>
                              <option value="US">US (+1)</option>
                              <option value="Canada">Canada (+1)</option>
                              <option value="UK">UK (+44)</option>
                          </select>
                          <i style={{color: '#272D67',left: '38px'}} className="fa fa-caret-down fa-lg select-country-array"></i>
                      </div>
                      <input pattern="[0-9]" style={ this.state.phoneNumber ? {paddingLeft:'56px'} : null } onChange={this.handleChange} onChange={this.handleChange} onKeyPress={this.handleKeyPressed.bind(this)} onKeyDown={this.handleKeyDown.bind(this)} name="phoneNumber" value={ this.state.phoneNumber } placeholder="Phone" type="text"></input>
                  </div>
                </li>
                <li>
                  <button className="p-a-n-button" onClick={this.handleSubmit}>
                    Sign up
                    <Loader onClick={(e)=>{ e.stopPropagation()}} active={this.state.butLoadShow} inverted size='huge' className={"but-load-style"}/>
                  </button>

                  <div className="resistration-signIn paragraphRegular4">Already have an account? <a href="/signin">Sign in</a></div>
                </li>
            </ul>

           
            <ul className="resistration-text-info-ul">
              <li>
                <i className="icon-check-circle"></i>
                <span style={{borderTop:'0'}}>Get products that work for 15% off</span>
              </li>
              <li>
                <i className="icon-check-circle"></i>
                <span>No subscription required</span>
              </li>
              <li>
                <i className="icon-check-circle"></i>
                <span>Top notch skin consultants</span>
              </li>
            </ul>
        </div>
    );
  }
}


function mapStateToProps(state) {
  const { helloava } = state;
  const { isFetching, isAuthenticated, authFailed, error } = helloava.auth;
  return { isFetching, isAuthenticated, authFailed, error };
}

function mapDispatchToProps(dispatch) {
  return {
    signIn: (email, password) => dispatch(signIn(email, password))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationPage);



// WEBPACK FOOTER //
// ./src/views/onboardingAA/RegistrationPage.js